// Eager slim slice of the tickets function barrel (#16 tickets slim).
//
// The full `./index.js` barrel re-exports the tickets function surface
// (ticketUtils, saveTicket, ticketLoaders, fetchResolutions,
// ticketStore, cycleStore, …). The unified shell used to drag ALL of it into its
// EAGER chunk by folding the tickets context via `sharedLibraries.js`.
//
// Tickets is now a lazy sub-app: the `/tickets*` + `/resolutions*` routes fold
// the FULL tickets context (components + functions + state) into the live shell
// context on first mount (workspace/pages/index.js → lazySharedLibPage). So the
// eager chunk only needs the tickets functions that get el.call'd from OUTSIDE a
// tickets-mounted component — i.e. on a surface that never folds the tickets
// context.
//
// An exhaustive grep of the whole eager surface (workspace app.js/pages/
// components/functions, shared/**, canvas, and the other lazy sub-apps' eager
// contexts) for `.call('<ticketsFn>')` found exactly these cross-route callers:
//   • saveTicket — el.call'd by the eager TicketsDetailModal (save),
//     the workspace AI layer (functions/aiWorkspaceOps.js aiUpdateTicket /
//     aiCreateTicket) on ANY route, and meet's openSuggestionModal (/meet).
//   • deleteTicket — el.call'd by TicketsDetailModal (delete) + the
//     AI layer (aiWorkspaceOps.js aiDeleteTicket).
//   • moveTicket — el.call'd by TicketsDetailModal (state change) + the AI layer
//     (aiWorkspaceOps.js aiMoveTicket).
//   • reloadTickets — el.call'd by the eager TicketsSidebar (filter apply),
//     which mounts on /tickets/status without folding.
//   • freshTicket — el.call'd by chat's MessageList (/chat) to seed a ticket
//     draft from a message.
// saveTicket.js carries save/delete/move; ticketUtils.js carries
// freshTicket (+ the colour maps / boilerplate fetch the modal & sidebar import
// directly); ticketLoaders.js carries reloadTickets. Every OTHER tickets function
// (getTicketStore, loadCycles, fetchResolutions, fetchGeneralTriage, …) is only
// ever el.call'd from a tickets-mounted component, i.e. AFTER a fold registers
// it — so it rides the lazy chunk, not this one.
//
// Byte note: ticketUtils.js is already eager (statically imported by the eager
// TicketDetailModal.js) and ticketLoaders.js is already eager (statically
// imported by workspace/pages/main.js). Only saveTicket.js is a net
// new eager module (~16KB) — the price of keeping the modal + AI writes + meet
// working from any route. All three import only shell/shared helpers (verified:
// no function file imports a component file), so this slice can never drag a
// heavy tickets component into the eager chunk.
//
// tickets/package.json has no `sideEffects: false`, so re-exporting through
// `./index.js` would NOT tree-shake (it would evaluate the whole barrel + pull
// every component the barrel's siblings touch). Each file below is therefore
// `export *`-ed from its light SOURCE file directly.
export * from './ticketUtils.js'
export * from './saveTicket.js'
export * from './ticketLoaders.js'
// The AI-answer view provider (ticketsAiViews) and its helpers: the shell reads
// the provider on ANY route, before the tickets context folds (workspace
// functions/assistantAppViews.js).
export * from './ticketsAnswer.js'
// The AI-answer FORM provider (ticketsAiForms), its opener and the report the
// shell-root TicketsDetailModal's save sends — read on ANY route.
export * from './ticketsAiForm.js'
